import { Grid } from '@mui/material'
import BoxDoc from '../boxDoc/boxDoc'
import { icons, imgs } from '../../constants/images'
type Props = {
    step: any
    viewType: string
    level1: any
    level2: any
    level3: any
    level4: any
    setLevel1: any
    setLevel2: any
    setLevel3: any
    setLevel4: any
    setLevelFiles: any
    setFile: any
    setOpenFile: any
    levelfiles: any
    inputFolder: any
    setInputFolder: any
    handleStepUpdate: any
    loadData: any
    loadDataLevel: any
    handleClickOpenCreate: any,
    permit?: any
}
export default function GridFolder(props: Props) {
    const {
        step,
        viewType,
        level1,
        level2,
        level3,
        level4,
        setLevel1,
        setLevel2,
        setLevel3,
        setLevel4,
        setLevelFiles,
        setFile,
        setInputFolder,
        setOpenFile,
        levelfiles,
        inputFolder,
        handleStepUpdate,
        loadData,
        loadDataLevel,
        handleClickOpenCreate,
        permit
    } = props
    return (
        <> {inputFolder?.stepView === 1 && <Grid container columns={14} spacing={2} sx={{
        }}>
            {level1?.filter((x: any) => x?.idFolder)?.length > 0 || levelfiles?.filter((x: any) => x?.fileStatus && x?.fileStatus !== 'ไม่ใช้งาน')?.length > 0 ?
                <>  {level1?.length > 0 ? level1?.map((x: any, i: number) => {
                    return (
                        <>{x?.idFolder ?
                            <BoxDoc
                                style={{ opacity: !x?.isEmpty ? '100%' : '50%', background: !x?.isEmpty ? '#f5f5f5' : '#e5e5e5' }}
                                icon={<icons.box1 />} title={x?.folderName} onClick={async () => {
                                    handleStepUpdate(x?.idFolder, 0)
                                    setInputFolder({ ...inputFolder, idReferFolder: x?.idFolder, layer: i, stepView: 2, permissionLevel: x?.permissionLevel,  permitLevel: permit?.find((x: any) => x?.code === 'Level2.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })
                                    const data = await loadDataLevel(x?.idFolder)
                                    const newArray = new Array(i)
                                    setLevel2([...newArray, ...data?.detailFolders])
                                    setLevelFiles([...newArray, ...data?.detailFiles])
                                }}
                                id={x.idFolder}
                                handleClickOpenCreate={handleClickOpenCreate}
                                inputFolder={inputFolder}
                                setInputFolder={setInputFolder}
                                detail={x}
                                stepView={1}
                                layer={i}
                                loadData={loadData}
                                checkbox />
                            : <></>}
                        </>
                    )
                }) :
                    <></>}
                    {levelfiles?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.length > 0 ? levelfiles?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.map((x: any, i: number) => {
                        return (
                            <>{x?.idFolder ?
                                <BoxDoc key={i} icon={<icons.box5 />} title={x?.fileName} onClick={() => {
                                    setFile(x)
                                    setOpenFile(true)
                                }}
                                    id={x?.idFile}
                                    detail={x}
                                    stepView={5}
                                    layer={i}
                                    type={'file'}
                                    levelfiles={levelfiles}
                                    setLevelFiles={setLevelFiles}
                                />
                                :
                                <></>}
                            </>

                        )
                    }) :
                        <>
                        </>}
                </>
                : <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '20px auto' }}>
                    <img src={imgs.myDocumentImage} alt='myDocumentImage' />
                </div>}

        </Grid>}
            {inputFolder?.stepView === 2 && <Grid container columns={14} spacing={2} sx={{
            }}>
                {level2?.filter((x: any) => x?.idFolder)?.length > 0 || levelfiles?.filter((x: any) => x?.fileStatus && x?.fileStatus !== 'ไม่ใช้งาน')?.length > 0 ?

                    <> {level2?.length > 0 ? level2?.map((x: any, i: number) => {
                        return (
                            <>{x?.idFolder ?
                                <BoxDoc
                                    style={{ opacity: !x?.isEmpty ? '100%' : '50%', background: !x?.isEmpty ? '#f5f5f5' : '#e5e5e5' }}
                                    icon={<icons.box2 />} title={x?.folderName} onClick={async () => {
                                        handleStepUpdate(x?.idFolder, 1)
                                        setInputFolder({ ...inputFolder, idReferFolder: x?.idFolder, layer: i, stepView: 3, permissionLevel: x?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level3.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })
                                        const data = await loadDataLevel(x?.idFolder)
                                        const newArray = new Array(i)
                                        setLevel3([...newArray, ...data?.detailFolders])
                                        setLevelFiles([...newArray, ...data?.detailFiles])
                                    }}
                                    id={x.idFolder}
                                    handleClickOpenCreate={handleClickOpenCreate}
                                    inputFolder={inputFolder}
                                    setInputFolder={setInputFolder}
                                    detail={x}
                                    stepView={2}
                                    layer={i}
                                    loadData={loadData}
                                    checkbox />
                                : <></>}
                            </>
                        )
                    }) :
                        <>
                        </>}
                        {levelfiles?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.length > 0 ? levelfiles?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.map((x: any, i: number) => {
                            return (
                                <>{x?.idFolder ?
                                    <BoxDoc key={i} icon={<icons.box5 />} title={x?.fileName} onClick={() => {
                                        setFile(x)
                                        setOpenFile(true)
                                    }}
                                        id={x?.idFile}
                                        detail={x}
                                        stepView={5}
                                        layer={i}
                                        type={'file'}
                                        levelfiles={levelfiles}
                                        setLevelFiles={setLevelFiles}
                                    />
                                    :
                                    <></>}
                                </>

                            )
                        }) :
                            <>
                            </>}
                    </> :
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '20px auto' }}>
                        <img src={imgs.myDocumentImage} alt='myDocumentImage' />
                    </div>}
            </Grid>}
            {inputFolder?.stepView === 3 && <Grid container columns={14} spacing={2} sx={{
            }}>
                {level3?.filter((x: any) => x?.idFolder)?.length > 0 || levelfiles?.filter((x: any) => x?.fileStatus && x?.fileStatus !== 'ไม่ใช้งาน')?.length > 0 ?
                    <>
                        {level3?.length > 0 ? level3?.map((x: any, i: number) => {
                            return (
                                <>{x?.idFolder ?
                                    <BoxDoc
                                        style={{ opacity: !x?.isEmpty ? '100%' : '50%', background: !x?.isEmpty ? '#f5f5f5' : '#e5e5e5' }}
                                        icon={<icons.box3 />} title={x?.folderName} onClick={async () => {
                                            handleStepUpdate(x.idFolder, 2)
                                            setInputFolder({ ...inputFolder, idReferFolder: x?.idFolder, layer: i, stepView: 4, permissionLevel: x?.permissionLevel,  permitLevel: permit?.find((x: any) => x?.code === 'Level4.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })
                                            const data = await loadDataLevel(x?.idFolder)
                                            const newArray = new Array(i)
                                            setLevel4([...newArray, ...data?.detailFolders])
                                            setLevelFiles([...newArray, ...data?.detailFiles])
                                        }}
                                        id={x.idFolder}
                                        handleClickOpenCreate={handleClickOpenCreate}
                                        inputFolder={inputFolder}
                                        setInputFolder={setInputFolder}
                                        detail={x}
                                        stepView={3}
                                        layer={i}
                                        loadData={loadData}
                                        checkbox />
                                    : <></>}
                                </>

                            )
                        }) :
                            <>
                            </>}
                        {levelfiles?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.length > 0 ? levelfiles?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.map((x: any, i: number) => {
                            return (
                                <>{x?.idFolder ?
                                    <BoxDoc key={i} icon={<icons.box5 />} title={x?.fileName} onClick={() => {
                                        setFile(x)
                                        setOpenFile(true)
                                    }}
                                        id={x?.idFile}
                                        detail={x}
                                        stepView={5}
                                        layer={i}
                                        type={'file'}
                                        levelfiles={levelfiles}
                                        setLevelFiles={setLevelFiles}
                                    />
                                    :
                                    <></>}
                                </>

                            )
                        }) :
                            <>
                            </>}
                    </> :
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '20px auto' }}>
                        <img src={imgs.myDocumentImage} alt='myDocumentImage' />
                    </div>}

            </Grid>}
            {inputFolder?.stepView === 4 && <Grid container columns={14} spacing={2} sx={{
            }}>
                {level4?.filter((x: any) => x?.idFolder)?.length > 0 || levelfiles?.filter((x: any) => x?.fileStatus && x?.fileStatus !== 'ไม่ใช้งาน')?.length > 0 ?
                    <>
                        {level4?.length > 0 ? level4?.map((x: any, i: number) => {
                            return (
                                <>{x?.idFolder ?
                                    <BoxDoc
                                        style={{ opacity: !x?.isEmpty ? '100%' : '50%', background: !x?.isEmpty ? '#f5f5f5' : '#e5e5e5' }}
                                        icon={<icons.box4 />} title={x?.folderName} onClick={async () => {
                                            handleStepUpdate(x.idFolder, 3)
                                            setInputFolder({ ...inputFolder, idReferFolder: x?.idFolder, layer: i, stepView: 5, permissionLevel: x?.permissionLevel,  })
                                            const data = await loadDataLevel(x?.idFolder)
                                            const newArray = new Array(i)
                                            setLevelFiles([...newArray, ...data?.detailFiles])

                                        }}
                                        id={x?.idFolder}
                                        handleClickOpenCreate={handleClickOpenCreate}
                                        inputFolder={inputFolder}
                                        setInputFolder={setInputFolder}
                                        detail={x}
                                        stepView={4}
                                        layer={i}
                                        loadData={loadData}
                                        checkbox />
                                    :
                                    <></>}
                                </>

                            )
                        }) :
                            <>
                            </>}
                        {levelfiles?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.length > 0 ? levelfiles?.filter((x: any) => x?.fileStatus && x?.fileStatus !== 'ไม่ใช้งาน')?.map((x: any, i: number) => {
                            return (
                                <>{x?.idFolder ?
                                    <BoxDoc key={i} icon={<icons.box5 />} title={x?.fileName} onClick={() => {
                                        setFile(x)
                                        setOpenFile(true)
                                    }}
                                        id={x?.idFile}
                                        detail={x}
                                        stepView={5}
                                        layer={i}
                                        type={'file'}
                                        levelfiles={levelfiles}
                                        setLevelFiles={setLevelFiles}
                                    />
                                    :
                                    <></>}
                                </>

                            )
                        }) :
                            <>
                            </>}
                    </> :
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '20px auto' }}>
                        <img src={imgs.myDocumentImage} alt='myDocumentImage' />
                    </div>}

            </Grid>}
            {inputFolder?.stepView === 5 && <Grid container columns={14} spacing={2} sx={{
            }}>
                {levelfiles?.filter((x: any) => x?.idFile)?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.length > 0 ? levelfiles?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.map((x: any, i: number) => {
                    return (
                        <>{x?.idFolder ?
                            <BoxDoc key={i} icon={<icons.box5 />} title={x?.fileName} onClick={() => {
                                setFile(x)
                                setOpenFile(true)
                            }}
                                id={x?.idFile}
                                detail={x}
                                stepView={5}
                                layer={i}
                                type={'file'}
                                levelfiles={levelfiles}
                                setLevelFiles={setLevelFiles}
                            />
                            :
                            <></>}
                        </>

                    )
                }) :
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '20px auto' }}>
                        <img src={imgs.myDocumentImage} alt='myDocumentImage' />
                    </div>}

            </Grid>}
        </>
    )
}
